<template>
  <div>
    <az-back-button :route="{name: 'consultaDeLicitacoes'}" text="Voltar para listagem"></az-back-button>
    <az-container>
      <credenciamento-visualizacao-acoes></credenciamento-visualizacao-acoes>
      <div class="az-tabs">
        <v-tabs left>
          <v-tab :to="construirRota(abas.dadosGerais.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.dadosGerais.titulo}}
          </v-tab>
          <v-tab :to="construirRota(abas.edital.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.edital.titulo}}
          </v-tab>
          <v-tab :to="construirRota(abas.itens.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.itens.titulo}}
          </v-tab>
          <v-tab :to="construirRota(abas.esclarecimentoImpugnacao.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.esclarecimentoImpugnacao.titulo}}
          </v-tab>
          <v-tab :to="construirRota(abas.resultado.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
            {{abas.resultado.titulo}}
          </v-tab>
        </v-tabs>
        <router-view></router-view>
      </div>
    </az-container>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import CredenciamentoVisualizacaoAcoes from '@/views/pages/commons/credenciamento/detalhe/acoes/CredenciamentoVisualizacaoAcoes.vue'

export default {
    name: 'CredenciamentoVisualizacao',
    components: { CredenciamentoVisualizacaoAcoes },
    data() {
        return {
            abas: {
                dadosGerais: {
                    titulo: 'Dados Gerais',
                    nomeRota: 'credenciamentoVisualizacaoDadosGerais'
                },
                edital: {
                    titulo: 'Edital',
                    nomeRota: 'credenciamentoVisualizacaoEdital'
                },
                itens: {
                    titulo: 'Itens',
                    nomeRota: 'CredenciamentoVisualizacaoLotesItens'
                },
                esclarecimentoImpugnacao: {
                    titulo: 'Esclarecimento/Impugnação',
                    nomeRota: 'credenciamentoVisualizacaoEsclarecimentoImpugnacao'
                },
                resultado: {
                    titulo: 'Resultado',
                    nomeRota: 'credenciamentoVisualizacaoResultado'
                },
                /*acompanhamento: {
                    titulo: 'Acompanhamento',
                    nomeRota: 'credenciamentoVisualizacaoAcompanhamento'
                },*/
            },
            licitacaoId: null,
        }
    },
    computed: {
        ...mapState(['licitacao']),
        isLicitacaoPresencial() {
            return this.licitacao && this.licitacao.modalidade
                ? this.licitacao.modalidade.includes('PRESENCIAL')
                : false
        }
    },
    async created() {
        await this.setLicitacaoId(this.$route.params.id)
    },
    async mounted() {
        await this.buscarDadosGerais()
    },
    async beforeRouteUpdate(_to, _from, next) {
        await this.buscarDadosGerais()
        next()
    },
    methods: {
        async buscarDadosGerais() {
            await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS_CREDENCIAMENTO, this.licitacaoId)
        },
        construirRota(name) {
            return {
                name,
                params: {id: this.licitacaoId}
            }
        },
        setLicitacaoId(licitacaoId) {
            this.licitacaoId = licitacaoId
        },
    }
}
</script>
<style lang="stylus">
.az-tabs
  margin: 20px

  .v-tabs__div
    text-transform: none

  .v-tabs__item--active
    font-weight: bold
    border-bottom: 1px solid white
    border-left: 1px solid #ccc
    border-right: 1px solid #ccc
    border-top: 1px solid #ccc
    border-radius: 2px

  .v-tabs__item
    color: #777777
    padding: 10px 20px

  .v-tabs__slider-wrapper
    display: none

  .v-tabs__container
    border-bottom: 1px solid #ccc

  .v-text-field__slot
    font-size: 14px

  .v-select__selections
    font-size: 14px

</style>